import { render, staticRenderFns } from "./Grls.vue?vue&type=template&id=1f107f51&"
import script from "./Grls.vue?vue&type=script&lang=js&"
export * from "./Grls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports